export function OnboardingBrandMark(): JSX.Element {
  return (
    <div className="fx-onb-brand-mark">
      <span className="mark">F</span>
      <span>fiscalo</span>
    </div>
  );
}
